import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import CityPage from "@/pages/CityPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/descubrir">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            
            {/* ¡Aquí está la magia! Cambiamos /city por /ciudad/:cityName */}
            <Route path="/ciudad/:cityId" element={<CityPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;